"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8314],{

/***/ 26432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var Button = function(props) {
    var color = props.color, path = props.path, text = props.text, backgroundColor = props.backgroundColor, border = props.border, width = props.width, icon = props.icon, iconPosition = props.iconPosition, link = props.link, handleSpotCounsellingFlow = props.handleSpotCounsellingFlow, trackingEvent = props.trackingEvent, _fontWeight = props.fontWeight, fontWeight = _fontWeight === void 0 ? "bold" : _fontWeight;
    var flexClasses = iconPosition === "right" ? "flex-row-reverse" : "flex-row";
    var commonClass = "".concat(color, " ").concat(backgroundColor, " ").concat(border || "border border-transparent", " ").concat(width, " rounded py-3 px-2 text-center text-sm ").concat(icon ? "".concat(flexClasses, " justify-center gap-2 flex items-center") : "inline-block");
    var fontWeightCss = function() {
        if (fontWeight == "regular") {
            return "font-normal";
        } else return "font-bold";
    };
    if (!(link || path)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        onClick: function() {
            if (trackingEvent) trackingEvent();
            if (handleSpotCounsellingFlow) handleSpotCounsellingFlow();
        },
        className: commonClass,
        children: [
            icon,
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: [
                    "leading-6",
                    fontWeightCss()
                ].join(" "),
                children: text
            })
        ]
    });
    return path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: path,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: commonClass,
            onClick: function() {
                if (trackingEvent) trackingEvent();
            },
            children: [
                icon,
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: text
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
        onClick: function() {
            if (trackingEvent) trackingEvent();
        },
        href: link,
        className: commonClass,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            icon,
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: [
                    "leading-6",
                    fontWeightCss()
                ].join(" "),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 55710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dy": function() { return /* binding */ fullLengthBannerData; },
/* harmony export */   "LP": function() { return /* binding */ writingPreferanceCardData; },
/* harmony export */   "kL": function() { return /* binding */ audienceSelectList; },
/* harmony export */   "lm": function() { return /* binding */ ExamLiveStatus; },
/* harmony export */   "q6": function() { return /* binding */ EXPERIMENT_SALES_LEAD; },
/* harmony export */   "tY": function() { return /* binding */ speakingTestBannerData; }
/* harmony export */ });
/* unused harmony export WritingExamPreference */
/* harmony import */ var page_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12615);
/* harmony import */ var utils_url_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54728);
/* harmony import */ var DataMapper_IeltsDateUploadData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56014);



var fullLengthBannerData = {
    heading: "Self prep bundle",
    subHeading: "Practice full length, sectional mock test and recordings to learn from",
    bannerRightImage: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/banner_image_right.png"),
    ctaText: "Practice Now",
    ctaClick: function() {
        return window.open((0,utils_url_utils__WEBPACK_IMPORTED_MODULE_1__/* .getIeltsMockTestUrl */ .xC)("/self-prep"), "_self");
    }
};
var speakingTestBannerData = {
    heading: "Speaking Practice",
    subHeading: "Schedule a speaking session",
    rightImageWeb: "/assets/images/banner/speaking_banner_girl_web.png",
    rightImageMob: "/assets/images/banner/speaking_banner_girl_mob.png",
    handleClick: function() {
        window.open(page_routes__WEBPACK_IMPORTED_MODULE_0__/* .navRoutes.IELTS_SPEAKING_CLUB */ .CZ.IELTS_SPEAKING_CLUB, "_self");
    }
};
var WritingExamPreference;
(function(WritingExamPreference) {
    WritingExamPreference["CBT"] = "CBT";
    WritingExamPreference["PBT"] = "PBT";
})(WritingExamPreference || (WritingExamPreference = {}));
var writingPreferanceCardData = function(isMobile) {
    return {
        heading: "Please select your preferred mode of Writing Test",
        preferenceOptions: [
            {
                value: WritingExamPreference.PBT,
                image: "/assets/images/ielts/writing_hand.svg",
                title: "Paper based test",
                subtitile: "Upload your answers"
            },
            {
                value: WritingExamPreference.CBT,
                image: "/assets/images/ielts/montior.svg",
                title: "Computer based test",
                subtitile: "Type your answers",
                isDisabled: isMobile,
                tag: isMobile ? "Only available on desktop" : ""
            }, 
        ],
        ctaText: "Start Test"
    };
};
var ExamLiveStatus;
(function(ExamLiveStatus) {
    ExamLiveStatus["STARTED"] = "STARTED";
    ExamLiveStatus["NOT_STARTED"] = "NOT_STARTED";
    ExamLiveStatus["ATTEMPTED"] = "ATTEMPTED";
    ExamLiveStatus["ENDED"] = "ENDED";
    ExamLiveStatus["NOT_ATTEMPTED"] = "NOT_ATTEMPTED";
    ExamLiveStatus["EVALUATED"] = "EVALUATED";
})(ExamLiveStatus || (ExamLiveStatus = {}));
var EXPERIMENT_SALES_LEAD = "EXPERIMENT_SALES_LEAD";
var audienceSelectList = [
    {
        id: DataMapper_IeltsDateUploadData__WEBPACK_IMPORTED_MODULE_2__/* .batchExamTypeDto.ACADEMIC */ .ow.ACADEMIC,
        text: "Academic"
    },
    {
        id: DataMapper_IeltsDateUploadData__WEBPACK_IMPORTED_MODULE_2__/* .batchExamTypeDto.GENERAL */ .ow.GENERAL,
        text: "General"
    }, 
];


/***/ }),

/***/ 87843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var hooks_useDevice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84367);




var Banner = function(param) {
    var heading = param.heading, subHeading = param.subHeading, hideExpertCall = param.hideExpertCall, hideSubHeading = param.hideSubHeading;
    var isMobile = (0,hooks_useDevice__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full pt-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-white md:px-8 rounded-[12px] w-full pb-4 md:py-10 shadow-[0px_1px_3px_0px_rgba(16,24,40,0.10),0px_1px_2px_0px_rgba(16,24,40,0.06)] flex flex-col-reverse md:flex-row items-center md:justify-center md:gap-4 md:relative z-20",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative md:static bg-[#F8F8FF] md:bg-white flex justify-center md:justify-end items-center px-4 pt-8 md:pt-0 rounded-t-[8px] order-[2] w-full md:w-3/5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/liy/expert_mocktest.png"),
                            height: isMobile ? 170 : 180,
                            width: isMobile ? 190 : 200,
                            alt: "liy-scholar-logo",
                            className: "z-20 object-contain"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: isMobile ? "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/liy/bg_mb.svg") : "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/liy/top_left_icon.svg"),
                            className: "absolute top-0 left-0 md:left-[auto] md:right-0 w-full md:w-auto h-full md:h-auto md:rounded-r-[12px]"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full px-4 md:px-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-[#424242] text-[18px] md:text-[26px] pt-4 md:pt-0 text-center md:text-left font-semibold pb-2 md:flex md:justify-start md:items-center md:gap-4",
                            children: [
                                !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/liy/call.svg"),
                                    width: 110,
                                    height: 110,
                                    alt: "call"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: heading ? heading : "Our IELTS Expert will call you soon!"
                                })
                            ]
                        }),
                        !hideSubHeading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-[14px] md:text-[#77768E] md:text-[18px] text-center md:text-left md:pt-4 pb-2",
                            children: subHeading ? subHeading : "The expert will create a personalised IELTS preparation plan for you"
                        }),
                        !hideExpertCall && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex justify-center md:justify-start items-center px-4 pt-2 md:pt-4 md:px-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-[#0D6008] bg-green-to-light p-2 md:px-4 rounded font-[400]",
                                children: "Expect a call in the next 2 hrs"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);


/***/ }),

/***/ 24085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var hooks_useDevice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84367);




var HeaderLogo = function(param) {
    var onClick = param.onClick, _alignment = param.alignment, alignment = _alignment === void 0 ? "center" : _alignment;
    var isMobile = (0,hooks_useDevice__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed top-0 left-0 w-full z-[998]",
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "py-4 border-b border-[#DBDBDB] shadow-2 bg-white w-full flex ".concat(alignment === "left" ? "pl-[148px] justify-start" : "justify-center"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/company_logo/new-header-logo.svg"),
                height: isMobile ? 24 : 37,
                width: isMobile ? 120 : 191,
                alt: "leap-scholar-logo"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderLogo);


/***/ }),

/***/ 19915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87357);
/* harmony import */ var _mui_material_LinearProgress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81458);
/* harmony import */ var hooks_useDevice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84367);






var ThankYouBanner = function(param) {
    var title = param.title, postAction = param.postAction, totalTime = param.totalTime;
    var totalTimeToUse = totalTime || 3000;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(totalTimeToUse), progressBar = ref[0], setProgressBar = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hideBanner = ref1[0], setHideBanner = ref1[1];
    var isMobile = (0,hooks_useDevice__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isMobile;
    var getPerOfProgress = function(value) {
        return value / totalTimeToUse * 100;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timer = setInterval(function() {
            setProgressBar(function(prevProgress) {
                if (prevProgress > 0) {
                    return prevProgress - 300;
                } else {
                    clearInterval(timer);
                    setHideBanner(true);
                    if (postAction) {
                        postAction();
                    }
                    return 0;
                }
            });
        }, 300);
        return function() {
            clearInterval(timer);
        };
    }, []);
    return !hideBanner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "border border-[#F5F5F7] bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center items-center px-4 pt-2 rounded-[8px] mt-2 mb-3 w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex justify-center items-center gap-2 w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/check_circle_fill.svg"),
                            height: isMobile ? 20 : 27,
                            width: isMobile ? 20 : 27,
                            alt: "tick"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-[#0D6008] text-[12px] md:text-[16px]",
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                sx: {
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_LinearProgress__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "determinate",
                    color: "inherit",
                    sx: {
                        color: "#44AC21",
                        height: "2px"
                    },
                    value: getPerOfProgress(progressBar)
                })
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "h-[52px] md:h-[59px]"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ThankYouBanner);


/***/ }),

/***/ 36728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_Ielts_IeltsOnboardingForms_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11403);


var useDemoAlias = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var demoAliasQuery = router.query[components_Ielts_IeltsOnboardingForms_utils__WEBPACK_IMPORTED_MODULE_1__/* .demoAliasQueryConstant */ .xj];
    var isMasterclassAlias = demoAliasQuery == components_Ielts_IeltsOnboardingForms_utils__WEBPACK_IMPORTED_MODULE_1__/* .demoAliasConstant.masterclass */ .b8.masterclass;
    var appendMasterclassAliasToQueryParams = function(url) {
        if (!isMasterclassAlias) return url;
        var aliasUrl = "".concat(components_Ielts_IeltsOnboardingForms_utils__WEBPACK_IMPORTED_MODULE_1__/* .demoAliasQueryConstant */ .xj, "=").concat(components_Ielts_IeltsOnboardingForms_utils__WEBPACK_IMPORTED_MODULE_1__/* .demoAliasConstant.masterclass */ .b8.masterclass);
        return url.includes("?") ? "".concat(url, "&").concat(aliasUrl) : "".concat(url, "?").concat(aliasUrl);
    };
    return {
        isMasterclassAlias: isMasterclassAlias,
        appendMasterclassAliasToQueryParams: appendMasterclassAliasToQueryParams
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDemoAlias);


/***/ }),

/***/ 56067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useABTesting; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_SpotCounselling_redux_SpotCounsellingApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40163);




function useABTesting(variantId) {
    // 0 -> unset or loading, 1-> original, 2-> experimental
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), abVariant = ref[0], setAbVariant = ref[1];
    var getVariantData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var variant;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,components_SpotCounselling_redux_SpotCounsellingApi__WEBPACK_IMPORTED_MODULE_2__/* .getAbVariant */ .Vp)(variantId);
                    case 2:
                        variant = _ctx.sent;
                        if (variant && variant.data) {
                            setAbVariant(variant.data);
                        } else {
                            setAbVariant(1);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getVariantData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getVariantData();
    }, []);
    return {
        abVariant: abVariant
    };
};


/***/ }),

/***/ 78314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IeltsExamType": function() { return /* binding */ IeltsExamType; },
  "default": function() { return /* binding */ ielts_elite_demo; },
  "getFilteredFormDataFromQueryObject": function() { return /* binding */ getFilteredFormDataFromQueryObject; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/decorator/WithAuth.tsx
var WithAuth = __webpack_require__(39494);
// EXTERNAL MODULE: ./components/Ielts/IeltsDemo/redux/IeltsDemoSlice.ts
var IeltsDemoSlice = __webpack_require__(4975);
// EXTERNAL MODULE: ./components/Ielts/IeltsEliteDemo/redux/IeltsEliteSlice.ts
var IeltsEliteSlice = __webpack_require__(48472);
// EXTERNAL MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/ieltsEliteFormJson.tsx
var ieltsEliteFormJson = __webpack_require__(27461);
// EXTERNAL MODULE: ./components/TofuOnbordingForms/utils.ts
var utils = __webpack_require__(62408);
// EXTERNAL MODULE: ./ga.ts
var ga = __webpack_require__(83138);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./scripts/segment.ts + 1 modules
var segment = __webpack_require__(83697);
// EXTERNAL MODULE: ./node_modules/crypto-js/sha256.js
var sha256 = __webpack_require__(52153);
var sha256_default = /*#__PURE__*/__webpack_require__.n(sha256);
// EXTERNAL MODULE: ./DataMapper/IeltsProfile/IeltsDemo.ts
var IeltsDemo = __webpack_require__(73113);
// EXTERNAL MODULE: ./hooks/ielts/useDemoAlias.ts
var useDemoAlias = __webpack_require__(36728);
// EXTERNAL MODULE: ./utils/country_utils.ts
var country_utils = __webpack_require__(20581);
// EXTERNAL MODULE: ./hooks/login/useLocation.ts
var useLocation = __webpack_require__(28531);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./components/Profile/ReferAndEarn/redux/ReferAndEarnActions.ts
var ReferAndEarnActions = __webpack_require__(94063);
// EXTERNAL MODULE: ./components/Profile/IeltsProfile/TestPrep/DataMapper/index.tsx
var DataMapper = __webpack_require__(55710);
// EXTERNAL MODULE: ./hooks/useDevice.ts
var useDevice = __webpack_require__(84367);
// EXTERNAL MODULE: ./components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/ThankYouBanner.tsx
var ThankYouBanner = __webpack_require__(19915);
// EXTERNAL MODULE: ./components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/Banner.tsx
var Banner = __webpack_require__(87843);
// EXTERNAL MODULE: ./components/LSRevamp/common/Button.tsx
var Button = __webpack_require__(26432);
// EXTERNAL MODULE: ./utils/url_utils.ts
var url_utils = __webpack_require__(54728);
// EXTERNAL MODULE: ./page_routes/index.ts
var page_routes = __webpack_require__(12615);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/constant.ts

var liyABVariant = {
    allCourse: 1,
    callNow: 2,
    menaUser: 3
};
var _obj;
var liyButtonData = (_obj = {}, (0,_define_property/* default */.Z)(_obj, liyABVariant.allCourse, {
    content: "While you wait, get started on your IELTS journey",
    buttonText: "Explore Courses"
}), (0,_define_property/* default */.Z)(_obj, liyABVariant.callNow, {
    content: "Don't want to wait?",
    subContent: "Start a conversation with our expert right away.",
    buttonText: "Call Now"
}), (0,_define_property/* default */.Z)(_obj, liyABVariant.menaUser, {
    content: "While you wait, take our Band Predictor Test to predict your IELTS score now",
    buttonText: "Attempt Test Now"
}), _obj);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/TestPrep/redux/TestPrepApi.ts
var TestPrepApi = __webpack_require__(68515);
// EXTERNAL MODULE: ./utils/events-utils.js
var events_utils = __webpack_require__(42477);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/BottomButton.tsx














var BottomButton = function(param) {
    var variant = param.variant;
    var ref, ref1, ref2, ref3;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var ref4 = (0,react.useState)(false), isTestAttempted = ref4[0], setIsTestAttempted = ref4[1];
    var MOCKTEST_EXAM_ID = 45;
    var dispatch = (0,es/* useDispatch */.I0)();
    var inboundSalesNumber = (0,es/* useSelector */.v9)(function(state) {
        return state.IeltsElite;
    }).inboundSalesNumber;
    var getMockTestData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return TestPrepApi/* TestPrepApi.fetchMockTestResultV4 */.F.fetchMockTestResultV4("45");
                    case 4:
                        res = _ctx.sent;
                        if (res.data.success && (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.data) && (res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ieltsScoreCard) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) setIsTestAttempted(true);
                        else setIsTestAttempted(false);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        setIsTestAttempted(false);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function getMockTestData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getMockTestData();
    }, []);
    var onclick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(variant == liyABVariant.callNow)) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch((0,IeltsEliteSlice/* lsqTriggerGetApiSlice */.Ge)());
                        _ctx.next = 4;
                        return (0,segment.trackEventAsync)("Click", {
                            widgetName: "L2E Thank You Page Subsection",
                            contentFormat: "Button",
                            widgetFormat: "Banner",
                            pageName: "L2E Thank You Page with Call Now"
                        });
                    case 4:
                        document.location.href = inboundSalesNumber ? "tel:".concat(inboundSalesNumber) : "tel:08065196400";
                        _ctx.next = 17;
                        break;
                    case 7:
                        if (!(variant == liyABVariant.allCourse)) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.next = 10;
                        return (0,segment.trackEventAsync)("Click", {
                            widgetName: "L2E Thank You Page Subsection",
                            contentFormat: "Button",
                            widgetFormat: "Banner",
                            pageName: "L2E Thank You Page with Courses"
                        });
                    case 10:
                        window.open(page_routes/* navRoutes.IELTS_ALL_BATCHES */.CZ.IELTS_ALL_BATCHES, "_self");
                        _ctx.next = 17;
                        break;
                    case 13:
                        if (!(variant == liyABVariant.menaUser)) {
                            _ctx.next = 17;
                            break;
                        }
                        _ctx.next = 16;
                        return (0,segment.trackEventAsync)("Click", {
                            contentName: " Attempt Test",
                            pageName: events_utils.ieltsPageName.THANQ_PAGE_MENA
                        });
                    case 16:
                        window.open((0,url_utils/* getIeltsMockTestUrl */.xC)(isTestAttempted ? "mock_test/result/".concat(MOCKTEST_EXAM_ID) : "mock_test/".concat(MOCKTEST_EXAM_ID)), "_self");
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onclick() {
            return _ref.apply(this, arguments);
        };
    }();
    if (variant) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-4 pt-8 md:py-8 md:max-w-[800px] mx-auto z-20 relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "fixed md:static bottom-0 left-0 w-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:flex md:justify-center md:items-stretch  w-full bg-white rounded-t-[12px] md:rounded-[12px] shadow-[0px_-9px_27px_0px_rgba(0,0,0,0.08)] ".concat(variant === liyABVariant.menaUser ? "" : "md:gap-4"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 md:p-6 text-[#03021B] text-center md:text-left w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pb-4 ".concat(variant === liyABVariant.menaUser ? "text-[14px] md:text-[15px]" : "md:text-[18px] font-bold", " "),
                                children: ((ref = liyButtonData[variant]) === null || ref === void 0 ? void 0 : ref.content) || ""
                            }),
                            ((ref1 = liyButtonData[variant]) === null || ref1 === void 0 ? void 0 : ref1.subContent) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs text-[#77768E] -mt-4 mb-4",
                                children: (ref2 = liyButtonData[variant]) === null || ref2 === void 0 ? void 0 : ref2.subContent
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                color: "text-white font-semibold !rounded-[4px] shadow-[0px_4px_8px_-2px_rgba(16,24,40,0.10),0px_2px_4px_-2px_rgba(16,24,40,0.06)]",
                                text: ((ref3 = liyButtonData[variant]) === null || ref3 === void 0 ? void 0 : ref3.buttonText) || "",
                                backgroundColor: "bg-[#443EFF] px-8 w-full md:w-auto",
                                trackingEvent: onclick,
                                icon: variant == liyABVariant.menaUser || variant == liyABVariant.allCourse ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icons/practice_tab/whitearrow.svg",
                                    width: 18,
                                    height: 18
                                }) : null,
                                iconPosition: "right"
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative w-full h-full",
                        children: [
                            variant === liyABVariant.menaUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/band-p.png"),
                                height: 140,
                                width: 350,
                                alt: "liy-scholar-logo",
                                className: "z-20 ml-auto relative"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/liy/illustration.png"),
                                height: 185,
                                width: 180,
                                alt: "liy-scholar-logo",
                                className: "z-20 ml-auto pt-4 mr-12 relative"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/liy/bg_button.svg"),
                                className: "absolute top-0 left-0 md:left-[auto] md:right-0 w-full md:w-auto h-full md:h-auto"
                            })
                        ]
                    })
                ]
            })
        })
    });
    else return null;
};
/* harmony default export */ var LiyThankYouPage2_BottomButton = (BottomButton);

// EXTERNAL MODULE: ./components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/HeaderLogo.tsx
var HeaderLogo = __webpack_require__(24085);
// EXTERNAL MODULE: ./public/static/scss/IeltsWebsite/PaymentBundle.module.scss
var PaymentBundle_module = __webpack_require__(73243);
var PaymentBundle_module_default = /*#__PURE__*/__webpack_require__.n(PaymentBundle_module);
// EXTERNAL MODULE: ./uiKit/components/Buttons/index.ts
var Buttons = __webpack_require__(10868);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/index.tsx





















var LiyThankYouPage2 = function(param) {
    var variant = param.variant;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var leadSource = (0,next_router.useRouter)().query.leadSource;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        dispatch((0,IeltsEliteSlice/* lsqTriggerSlice */.de)(DataMapper/* EXPERIMENT_SALES_LEAD */.q6));
    }, []);
    (0,react.useEffect)(function() {
        if (variant == liyABVariant.callNow) {
            (0,segment.trackEventAsync)("Page Viewed", {
                pageName: "L2E Thank You Page with Call Now"
            });
        } else if (variant == liyABVariant.allCourse) {
            (0,segment.trackEventAsync)("Page Viewed", {
                pageName: "L2E Thank You Page with Courses"
            });
        } else if (variant == liyABVariant.menaUser) {
            var flowType = "Onboarding";
            if (leadSource === "Web Dashboard" || leadSource === "Reschedule Dashboard" || leadSource === "Async Demo Screen") {
                flowType = "Dashboard";
            }
            (0,ga.fireTagEvent)("Signup_MENA");
            (0,segment.trackEventAsync)("Page Viewed", {
                pageName: events_utils.ieltsPageName.THANQ_PAGE_MENA,
                flowType: flowType
            });
        }
    }, [
        variant
    ]);
    var handleGoToDashboard = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,segment.trackEventAsync)("Click", {
                            contentName: "Go to dashboard",
                            pageName: events_utils.ieltsPageName.THANQ_PAGE_MENA
                        });
                    case 2:
                        window.open(page_routes/* navRoutes.IELTS_STUDENT_DASHBOARD */.CZ.IELTS_STUDENT_DASHBOARD, "_self");
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleGoToDashboard() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            "w-full bg-[#fbfcfe] pt-10 md:pt-14 md-min-w-[1000px] min-h-[800px] md:min-h-screen",
            (PaymentBundle_module_default())["poppins-font-family"], 
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogo/* default */.Z, {
                onClick: function() {
                    if (variant === liyABVariant.menaUser) {
                        router.push(page_routes/* navRoutes.IELTS_STUDENT_DASHBOARD */.CZ.IELTS_STUDENT_DASHBOARD);
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 pt-8 md:max-w-[800px] mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThankYouBanner/* default */.Z, {
                        title: "Great! You're a step closer to IELTS success.",
                        totalTime: 1500
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {})
                ]
            }),
            variant === liyABVariant.menaUser ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons/* Button */.z, {
                variant: "primary",
                customCss: "w-full max-w-[300px] px-4 py-[14px] md:max-w-[221px] rounded-xl flex items-center gap-2 justify-center md:mx-auto mt-6 !fixed md:!static translate-x-[-50%] left-[50%] md:!translate-x-[0]",
                onClick: handleGoToDashboard,
                loadingAnimation: {
                    duration: 5,
                    onComplete: handleGoToDashboard
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Go To Dashboard"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/images/conversion-page/right-arrow-white-mobile.svg",
                        height: 20,
                        width: 20
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:max-w-[800px] mx-auto relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[50px] rotate-90 border border-dashed border-[#CBCAD5] absolute top-20 left-50 z-0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LiyThankYouPage2_BottomButton, {
                        variant: variant
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TestPrep_LiyThankYouPage2 = (LiyThankYouPage2);

// EXTERNAL MODULE: ./hooks/useABTesting.ts
var useABTesting = __webpack_require__(56067);
// EXTERNAL MODULE: ./components/Ielts/IeltsEliteDemo/redux/IeltsEliteApi.ts
var IeltsEliteApi = __webpack_require__(97521);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/CallUsBanner.tsx







var CallUsBanner = function() {
    var inboundSalesNumber = (0,es/* useSelector */.v9)(function(state) {
        return state.IeltsElite;
    }).inboundSalesNumber;
    var copyToClipboard = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var number;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        number = inboundSalesNumber ? "".concat(inboundSalesNumber) : "08065196400";
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return navigator.clipboard.writeText(number);
                    case 4:
                        react_toastify_esm/* toast.success */.Am.success(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center text-sm",
                            children: "Number copied to clipboard!"
                        }), {
                            position: "bottom-center",
                            style: {
                                background: "black",
                                width: "250px",
                                margin: "auto",
                                borderRadius: "8px"
                            },
                            closeButton: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "hidden"
                            })
                        });
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error("Failed to copy text: ", _ctx.t0);
                        react_toastify_esm/* toast.error */.Am.error("Failed to copy the number. Please try again.");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return function copyToClipboard() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative bg-white rounded-xl shadow py-8 px-[36px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "justify-between items-center flex w-full flex-col md:flex-row gap-y-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "justify-center items-center gap-[22px] flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-col justify-start items-start gap-1.5 inline-flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "self-stretch text-black text-[22px] font-bold font-['Noto Sans'] leading-[30.80px] md:text-left text-center",
                                    children: "Don't want to wait?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "justify-start items-start gap-1.5 inline-flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center text-[#77768e] text-sm font-normal font-['Figtree'] leading-[21px]",
                                        children: "Start a conversation with our expert right away."
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "justify-start items-center gap-6 flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#8b8aa2] text-base font-medium font-['Poppins'] leading-normal",
                                        children: "call us on"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-black text-base font-bold font-['Public Sans'] leading-normal",
                                        children: inboundSalesNumber ? "".concat(inboundSalesNumber) : "08065196400"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[47px] border border-[#e2e2e8]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return copyToClipboard();
                                            case 2:
                                                return _ctx.abrupt("return", _ctx.sent);
                                            case 3:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                })),
                                className: "p-4 bg-[#f8f7ff] rounded-lg justify-center items-center gap-2 flex cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/copy.svg"),
                                        height: 24,
                                        width: 24
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#7672f7] text-base font-bold font-['Public Sans'] leading-normal",
                                        children: "Copy Number"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                newestOnTop: false,
                closeOnClick: true,
                rtl: false,
                pauseOnHover: true
            })
        ]
    });
};
/* harmony default export */ var LiyThankYouPage2_CallUsBanner = (CallUsBanner);

;// CONCATENATED MODULE: ./components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/LiyFlowThankyouPage.tsx
















var LiyFlowThankyouPage = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,IeltsEliteSlice/* lsqTriggerSlice */.de)(DataMapper/* EXPERIMENT_SALES_LEAD */.q6));
        (0,segment.trackEventAsync)("Page Viewed", {
            pageName: "L2E Thank You Page with Call Now"
        });
    }, []);
    var handleGoToDashboard = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,segment.trackEventAsync)("Click", {
                            contentName: "Go to dashboard",
                            pageName: events_utils.ieltsPageName.THANQ_PAGE_MENA
                        });
                    case 2:
                        window.open(page_routes/* navRoutes.IELTS_STUDENT_DASHBOARD */.CZ.IELTS_STUDENT_DASHBOARD, "_self");
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleGoToDashboard() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            "w-full bg-[#fbfcfe] pt-10 md:pt-14 md-min-w-[1000px] min-h-[800px] md:min-h-screen flex flex-col items-center md:block relative",
            (PaymentBundle_module_default())["poppins-font-family"], 
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogo/* default */.Z, {
                onClick: function() {}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 pt-8 md:max-w-[900px] mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThankYouBanner/* default */.Z, {
                        title: "Great! You're a step closer to IELTS success."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {
                        heading: "Our IELTS Expert will call you soon to book an evaluation.",
                        subHeading: "During the evaluation with the teacher, discuss your test responses and tips on improving your IELTS score."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiyThankYouPage2_CallUsBanner, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                        variant: "primary",
                        customCss: "w-full max-w-[300px] px-4 py-[14px] md:max-w-[221px] rounded-xl flex items-center gap-2 justify-center mt-6 mx-auto sticky bottom-0",
                        onClick: handleGoToDashboard,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Back To Dashboard"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LiyThankYouPage2_LiyFlowThankyouPage = (LiyFlowThankyouPage);

;// CONCATENATED MODULE: ./pages/ielts-preparation-online/ielts-elite-demo/index.tsx




























var PageLoadingView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6259).then(__webpack_require__.bind(__webpack_require__, 76259));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76259)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "..."
        });
    }
});
var IeltsExamType;
(function(IeltsExamType) {
    IeltsExamType["ACADEMIC"] = "ACADEMIC";
    IeltsExamType["GENERAL"] = "GENERAL";
    IeltsExamType["OTHER"] = "OTHER";
})(IeltsExamType || (IeltsExamType = {}));
var getFilteredFormDataFromQueryObject = function(givenData) {
    var newData = (0,_object_spread/* default */.Z)({}, givenData);
    var requiredFormValues = new Set(ieltsEliteFormJson/* ieltsEliteFormRequiredFields */.Gk);
    for(var key in newData){
        if (!requiredFormValues.has(key)) delete newData[key];
    }
    return newData;
};
var Calender = function(param) {
    var auth = param.auth;
    var userInfo = (0,es/* useSelector */.v9)(function(state) {
        return state.referAndEarn;
    }).userInfo;
    var ieltsStage = (0,es/* useSelector */.v9)(function(state) {
        return state.IeltsElite;
    }).ieltsStage;
    var abVariant = (0,useABTesting/* default */.Z)("ielts_liy_thank_you").abVariant;
    var userCountry = (0,useLocation/* default */.Z)().userCountry;
    var router = (0,next_router.useRouter)();
    var formDetailsObjectFromQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getFilteredFormDataFromQueryObject(router.query)), {
        phone: userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone
    });
    var _query = router.query, formStage = _query.formStage, abTest = _query.abTest, leadSource = _query.leadSource, country = _query.country, flow = _query.flow;
    var isLoggedIn = auth === null || auth === void 0 ? void 0 : auth.isValid;
    var isLiyFlow = flow === "liy";
    var formVariation = abTest === "true" ? 1 : 0;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isMasterclassAlias = (0,useDemoAlias/* default */.Z)().isMasterclassAlias;
    var source = lib/* isMobile */.tq ? "MWEB" : "WEB";
    var ref = (0,react.useState)(false), isMenaUser = ref[0], setIsMenaUser = ref[1];
    var ref1 = (0,react.useState)(false), countryLoading = ref1[0], setCountryLoading = ref1[1];
    (0,react.useEffect)(function() {
        setIsMenaUser((0,country_utils/* checkIfMENAUser */.D7)(userCountry));
    }, [
        userCountry
    ]);
    var handleYtEvents = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var whenIelts, whatCareerStage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        whenIelts = formDetailsObjectFromQuery.whenIelts, whatCareerStage = formDetailsObjectFromQuery.whatCareerStage;
                        if (!(whenIelts === "BOOKED_EXAM" && whatCareerStage === "WORKING")) {
                            _ctx.next = 5;
                            break;
                        }
                        (0,segment.trackEventAsync)("IELTS_YT_Working_AlreadyBooked");
                        _ctx.next = 5;
                        return (0,ga.fireTagEvent)("IELTS_YT_Working_AlreadyBooked", {
                            name: formDetailsObjectFromQuery["name"],
                            hashed_email: sha256_default()(formDetailsObjectFromQuery["emailId"]).toString(),
                            hashed_phone: sha256_default()(formDetailsObjectFromQuery["phone"]).toString()
                        });
                    case 5:
                        if (whenIelts === "BOOKED_EXAM") (0,segment.trackEventAsync)("IELTS_YT_AlreadyBooked");
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleYtEvents() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchSlotsAndPostFormDataFromQuery = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var marketingEventName, isNewUser, isNewUser1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (formDetailsObjectFromQuery) handleYtEvents();
                        marketingEventName = isMasterclassAlias ? "Ielts demoMC lead marketing" : "Ielts demo lead marketing";
                        isNewUser = router.query["isNewUser"] || "0";
                        if (!(formVariation != IeltsDemo/* DemoFormAbVariants.FORM_1_CALENDAR_FORM_2 */.dn.FORM_1_CALENDAR_FORM_2)) {
                            _ctx.next = 15;
                            break;
                        }
                        if ((0,utils/* isObjectEmpty */.nK)(formDetailsObjectFromQuery)) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 7;
                        return (0,ga.fireTagEvent)(marketingEventName, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formDetailsObjectFromQuery), {
                            hashed_email: sha256_default()(formDetailsObjectFromQuery["emailId"]).toString(),
                            hashed_phone: sha256_default()(formDetailsObjectFromQuery["phone"]).toString(),
                            isNewUser: isNewUser
                        }));
                    case 7:
                        if ((0,country_utils/* checkIfMENAUser */.D7)(country)) {
                            dispatch((0,IeltsEliteSlice/* updatePostFillIeltsEliteNudgeForm */.XS)(function() {
                                IeltsEliteApi/* ieltsEliteApis.menaEventApi */.i.menaEventApi();
                            }));
                        }
                        dispatch((0,IeltsEliteSlice/* fetchPostIeltsEliteNudgeForm */.NS)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formDetailsObjectFromQuery), {
                            source: source,
                            qeEngineCallBack: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(QeType) {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (!(leadSource === "EXPERIMENT_SALES_LEAD")) {
                                                    _ctx.next = 5;
                                                    break;
                                                }
                                                _ctx.next = 3;
                                                return (0,segment.trackEventAsync)("Ielts demo lead marketing", formDetailsObjectFromQuery);
                                            case 3:
                                                _ctx.next = 6;
                                                break;
                                            case 5:
                                                {
                                                    if (QeType === IeltsEliteSlice/* UserQeData.TYPE2 */.Ih.TYPE2) {
                                                        window.open("ielts-elite-demo/masterclass-calendar", "_self");
                                                    } else {}
                                                }
                                            case 6:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(QeType) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        })));
                        (0,segment.trackEventAsync)("Ielts demo lead marketing", formDetailsObjectFromQuery);
                        _ctx.next = 13;
                        break;
                    case 12:
                        {
                            dispatch((0,IeltsEliteSlice/* runIeltsQualificationEngineAction */.D$)(false));
                        }
                    case 13:
                        _ctx.next = 25;
                        break;
                    case 15:
                        dispatch((0,IeltsEliteSlice/* runIeltsQualificationEngineAction */.D$)(false));
                        if (!(!(0,utils/* isObjectEmpty */.nK)(formDetailsObjectFromQuery) && formStage === "1")) {
                            _ctx.next = 20;
                            break;
                        }
                        {
                            dispatch((0,IeltsDemoSlice/* setFormData */.U5)(formDetailsObjectFromQuery));
                        }
                        _ctx.next = 25;
                        break;
                    case 20:
                        if (!(!(0,utils/* isObjectEmpty */.nK)(formDetailsObjectFromQuery) && formStage === "2")) {
                            _ctx.next = 25;
                            break;
                        }
                        (0,segment.trackEventAsync)("Ielts demo lead marketing", formDetailsObjectFromQuery);
                        isNewUser1 = router.query["isNewUser"] || "0";
                        _ctx.next = 25;
                        return (0,ga.fireTagEvent)(marketingEventName, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formDetailsObjectFromQuery), {
                            hashed_email: sha256_default()(formDetailsObjectFromQuery["emailId"]).toString(),
                            hashed_phone: sha256_default()(formDetailsObjectFromQuery["phone"]).toString(),
                            isNewUser: isNewUser1
                        }));
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchSlotsAndPostFormDataFromQuery() {
            return _ref.apply(this, arguments);
        };
    }();
    var viewLogic = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,IeltsEliteSlice/* updatePostGetStageAction */.Dr)(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(studentStage) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (studentStage === IeltsEliteSlice/* IeltsStageType.LS_USER_ACQUIRED */.QW.LS_USER_ACQUIRED) {} else {
                                                fetchSlotsAndPostFormDataFromQuery();
                                            }
                                        case 1:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(studentStage) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                        dispatch((0,IeltsEliteSlice/* fetchGetIeltsStage */.Wv)());
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function viewLogic() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        dispatch((0,IeltsEliteSlice/* fetchGetIeltsStage */.Wv)());
        dispatch(ReferAndEarnActions/* referAndEarnActions.fetchUserInfo */.F.fetchUserInfo());
        dispatch((0,IeltsEliteSlice/* fetchInboundSalesNumberSlice */.k9)());
    }, []);
    (0,react.useEffect)(function() {
        if (userInfo.phone) {
            if (formVariation == 0 || formVariation == 1) {
                viewLogic();
            }
        }
    }, [
        formVariation,
        userInfo.phone,
        ieltsStage
    ]);
    (0,react.useEffect)(function() {
        var countryLoadingTimeout = setTimeout(function() {
            setCountryLoading(true);
        }, 1000);
        return function() {
            return clearTimeout(countryLoadingTimeout);
        };
    }, []);
    if (!countryLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoadingView, {});
    else if (isLiyFlow) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LiyThankYouPage2_LiyFlowThankyouPage, {});
    else return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestPrep_LiyThankYouPage2, {
        variant: isMenaUser ? liyABVariant.menaUser : lib/* isMobile */.tq ? abVariant : liyABVariant.allCourse
    });
};
/* harmony default export */ var ielts_elite_demo = ((0,WithAuth/* default */.Z)(Calender, true));


/***/ })

}]);